import * as firebase from "firebase/app"
import "firebase/storage"
import AppService from "./app-service"

const path = "notes"

export default class NoteService extends AppService {

  constructor() {
    super({ path })
  }

  getNoteImage(noteId) {
    return this.http.get(`${path}/${noteId}/image`) 
  }

  removeNoteImage(noteId, image) {
    return firebase.storage().ref(`${path}/${noteId}/image`).child(image.name).delete()
  }

  findUserNotes(userId, options) {

    let showAll = false

    if (options && options.showAll)
      showAll = options.showAll

    return this.http.get(`user-notes?userId=${userId}&showAll=${showAll}`) 
  }

  setNoteViewed(noteId, userId) {
    return this.http.put(`/user-notes/${noteId}/${userId}/viewed`)
  }
}